// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style_buttons__1nuMc"};